import axios from "axios";
import authClient from "../app/auth/Auth";
import { discoverService } from "../app/discover-service";

const apiClient = () => {
  const axiosInstance = axios.create({
    baseURL: discoverService("api"),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authClient.getAccessToken()}`,
    },
  });

  // If the token exists but it is expired we renew the session
  axiosInstance.interceptors.request.use(async (config) => {
    if (!authClient.isAuthenticated() && authClient.getAccessToken()) {
      await authClient.checkSession();
    }
    config.headers.Authorization = `Bearer ${authClient.getAccessToken()}`;
    return config;
  });

  return {
    post: (path, body) => axiosInstance.post(path, body),
    put: (path, body) => axiosInstance.put(path, body),
    patch: (path, body) => axiosInstance.patch(path, body),
    get: (path, options) => axiosInstance.get(path, options),
    delete: (path, body) => axiosInstance.delete(path, { data: body }),
  };
};

export default apiClient;
